/*SYSTEM IMPORTS*/
import React from 'react'
import c from 'classnames'
import Img from 'components/Img'
// import Logo from 'components/ui/Logo'

// import Ratio from 'components/Ratio'

import PlayIcon from 'images/play-icon.png'


import './style'
import './media'

/*Images*/

const VideoItem = props =>(
    <div className={c("video-item", props.className)} onClick={()=>props.onClick(props.id)}>
        <div className="video-item__main-wrapper">
            <div className="video-item__wrapp">
                {/* <div className="video-item__overlay">
                    <Img src={PlayIcon} className="play-icon"/>
                </div> */}
                {props.image}
                {props.children}
            </div>
            <div className="video-item__title">
                {props.title}
            </div>
        </div>
    </div>
)

export default VideoItem